<template>
  <Modal v-model="config" title="订单详情" :width="800">
    <Table :columns="columns" :data="list"></Table>
  </Modal>
</template>

<script>
import { orderDetail } from "api/domain.js";
export default {
  name: "orderInfoModal",
  props: {
    id: {
      type: String,
      default: "",
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      columns: [
        {
          width: "80",
          title: "序号",
          type: "index",
        },
        {
          title: "产品名称",
          key: "goodsName",
          align: "center",
        },
        {
          title: "产品类型",
          key: "type",
          align: "center",
          render: (h, { row }) => {
            let title = "";
            switch (row.type) {
              case 0:
                title = "注册";
                break;
              case 1:
                title = "续费";
                break;
              case 2:
                title = "转入";
                break;
            }
            return h("div", title);
          },
        },
        {
          title: "单价",
          key: "price",
          align: "center",
          render: (h, { row }) => {
            return h("div", row.price + "元/年");
          },
        },
        {
          title: "数量",
          key: "counts",
        },
        {
          title: "总价",
          key: "amount",
          render: (h, { row }) => {
            return h("div", row.amount + "元");
          },
        },
      ],
      list: [],
    };
  },
  computed: {
    config: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  watch: {
    config: {
      immediate: true,
      handler(val) {
        if (val) {
          this.req_orderDetail();
        }
      },
    },
  },
  methods: {
    async req_orderDetail() {
      try {
        const { code, data } = await orderDetail({ orderNo: this.id });
        if (code === 200) {
          this.list = data.list;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
